"use client";

import React, { useState } from "react";
import { PageBlogOverviewSchema } from "@/sanity/pages/PageBlogOverviewTemplate";
import { PortableText } from "@portabletext/react";
import {
  customRichTextComponent,
  richTextComponent,
} from "@/sanity/sanityPortableText";
import Header from "@/components/global/partials/Header";
import Footer from "@/components/global/partials/Footer";
import { GroqImage } from "@/helpers/Image";
import Image from "next/image";
import { CTAButton } from "@/shadcn/ui/button";
import footerLogo from "@/public/global/footer-logo.svg";
import Link from "next/link";
import { cn } from "@/lib/utils";
import Chip from "../global/ui/Chip";
import { motion } from "framer-motion";
import bg from "@/public/global/bg-art.jpg";
import BlogGrid from "../pageComponents/overview/BlogGrid";
import ChipSerif from "../global/ui/ChipSerif";
import NavBarV2 from "../global/partials/HeaderV2";
import LastCTASection from "../global/sections/LastCTA";

export default function PageBlogOverviewJSX({
  data,
}: {
  data: PageBlogOverviewSchema;
}) {
  return (
    <>
      {data?.settings.header && (
        <NavBarV2 headerData={data.settings.header} animate={true} />
      )}
      <section
        id="hero-section"
        className="relative overflow-clip px-[2rem] pt-[2rem] lg:px-[5rem] lg:pt-[5rem]"
      >
        <div className="relative overflow-clip w-[min(229.25rem,100%)] mx-auto rounded-[2rem] lg:rounded-[5rem] py-[13rem] lg:py-[18.75rem]">
          <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-[#F6F9F7] to-[#E6F2EB]">
            <Image
              className="absolute left-1/2 -translate-x-1/2 bottom-0 !w-[max(100%,90rem)] !max-w-none !h-full object-cover object-top mix-blend-luminosity opacity-[.36]"
              src={bg}
              quality={100}
              alt="background art"
            />
          </div>

          <div className="container flex relative z-10 flex-col items-center px-[3rem]">
            {data?.heroChip && <ChipSerif text={data.heroChip} />}

            {data?.heroText && (
              <div className="richtext w-[min(85rem,100%)] prose-p:w-[min(64.75rem,100%)]">
                <PortableText
                  value={data.heroText}
                  components={richTextComponent}
                />
              </div>
            )}
          </div>
        </div>
      </section>

      <BlogGrid
        items={data.blogPosts}
        uniqueTags={data.uniqueTags}
        className="pb-[3.5rem] lg:pb-[15.25rem]"
      />

      <LastCTASection
        chip={data?.lastChip}
        text={data?.lastText}
        cta={data?.lastCTA}
      />

      <Footer data={data?.settings?.footer} />
    </>
  );
}
